import React from 'react';
import '../css/Cart.css';
import { FaTimes, FaTrash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import ProductImage from './ProductImage';

const Cart = ({ isOpen, onClose, items, onRemoveItem, onUpdateQuantity }) => {
    const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const navigate = useNavigate();
    const handleCheckout = () => {
        onClose();
        navigate('/checkout');
    };

    return (
        <>
            <div className={`cart-overlay ${isOpen ? 'active' : ''}`} onClick={onClose} />
            <div className={`cart-sidebar ${isOpen ? 'active' : ''}`}>
                <div className="cart-header">
                    <h2>Кошик</h2>
                    <button className="close-button" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="cart-items">
                    {items.length === 0 ? (
                        <div className="cart-empty">Кошик порожній</div>
                    ) : (
                        items.map((item) => (
                            <div key={item.id} className="cart-item">
                                <Link
                                    to={`/products/${item.slug || item.id}`}
                                    className="cart-item-link"
                                    onClick={onClose}
                                >
                                    <ProductImage src={item.photo} alt={item.name_ua} className="cart-item-image" />
                                </Link>
                                <div className="cart-item-details">
                                    <Link
                                        to={`/products/${item.slug || item.id}`}
                                        className="cart-item-name-link"
                                        onClick={onClose}
                                    >
                                        <h3>{item.name_ua}</h3>
                                    </Link>
                                    <div className="cart-item-price">{item.price} грн</div>
                                    <div className="cart-item-controls">
                                        <div className="quantity-controls">
                                            <button 
                                                onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                                                disabled={item.quantity <= 1}
                                            >
                                                -
                                            </button>
                                            <span>{item.quantity}</span>
                                            <button 
                                                onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                                            >
                                                +
                                            </button>
                                        </div>
                                        <button 
                                            className="remove-button"
                                            onClick={() => onRemoveItem(item.id)}
                                        >
                                            <FaTrash />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {items.length > 0 && (
                    <div className="cart-footer">
                        <div className="cart-total">
                            <span>Всього:</span>
                            <span>{total.toFixed(2)} грн</span>
                        </div>
                        <button className="checkout-button" onClick={handleCheckout}>
                            Оформити замовлення
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default Cart; 